import React, { Fragment, useEffect, useState } from "react";
import { Form, Col, Row, Spin, Divider } from "antd";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Title from "antd/es/typography/Title";
import JobDetailsPages from "../job-Search-Pages/JobDetailsPage";
import { setSelectedJob } from "../../state/actions/job";
import { fetchjobById } from "../../services/elastic.service";
import "./ApplyJobCAQPage.css";

const PublicApplyJobPage: React.FC<any> = (props) => {
    const { setSelectedJob, selectedJob, isLoggedIn } = props;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [jobIdValue, setJobIdValue] = useState('')
    let params = useParams();
    const jobId = params.jobId;

    useEffect(() => {
        if (jobId && isLoggedIn) {
            setLoading(true);
            getJobs(jobId);
        } else if (jobId) {
            localStorage.setItem('redirectUrl', `/job/${jobId}`);
            navigate('/login', { replace: true });
        }
    }, [jobId]);

    const getJobs = (jobId: string) => {
        fetchjobById(jobId).then((res: any) => {
            setLoading(false);
            res = res.hits && res.hits.length ? res.hits[0] : {};
            if (res && Object.keys(res).length) {
                setJobIdValue(jobId);
                setSelectedJob(res);
            }
        }, err => {
            setJobIdValue('');
            setLoading(false);
        })
    }



    return (
        <Fragment>
            <Row className="homeHeaderBg ">
                <Col span={24}><h2 className="text-center text-white">&nbsp;</h2></Col>
            </Row>

            {loading ? <div className="TextCenter pt-2"> < Spin tip="Loading" key={0} size="small" /> </div >
                : <Fragment>

                    <Row justify={'center'} >
                        <Col xs={22} sm={20} md={20} lg={16} className="pa-10 white-container mb-10 mr-0 ml-0">

                            <Form.Item className="TextCenter">
                                <Title className="mb-0" level={3}>{selectedJob?._source?.Job_Title__c}</Title>
                            </Form.Item>
                            <Divider className="mt-0" />


                            {jobIdValue &&

                                <JobDetailsPages jobId={jobId} />

                            }
                            {!jobIdValue && !loading &&

                                <Title className="mt-5 mb-1" level={5}>Unfortunately this job is no longer accepting applications!</Title>

                            }

                        </Col>
                    </Row>


                </Fragment>
            }
        </Fragment>
    );
};


const mapStateToProps = (state: any) => {
    return {
        user: state.reducer.auth.user,
        isLoggedIn: state.reducer.auth.isLoggedIn,
        selectedJob: state.reducer.job.selectedJob
    }
};

function mapDispatchToProps(dispatch: any) {
    return { setSelectedJob: (payload: any) => dispatch(setSelectedJob(payload)), };
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicApplyJobPage)
